import React from "react";
import { useRecoilState } from "recoil";
import {
  newAllDropDownState,
  PatientState,
  dummyDropDowns,
} from "../../data/atoms";
import { PatientVM } from "../../models/PatientVM";
import { useHistory } from "react-router";
import iphoneImg from "../../assets/images/iphone.png";
import androidImg from "../../assets/images/android.png";
import { IonImg, IonPage } from "@ionic/react";
import { IonButton } from "@ionic/react";
import proactiveYouLogo from "../../assets/images/proactive-you-mobile.svg";
interface Props {
  HideProactiveModal: Function;
  onRegisterPatient?: () => void;
}
const ProactiveYouModal: React.FC<Props> = ({
  HideProactiveModal,
  onRegisterPatient,
}) => {
  const [newAllDropDown, setNewAllDropDown] =
    useRecoilState(newAllDropDownState);
  const [patientInfo, setpatientInfo] = useRecoilState(PatientState);
  let history = useHistory();

  async function GetPatientDetails() {
    HideProactiveModal(false);
    window.location.href = window.location.origin + "/patient-page";
  }

  const handleRegisterPatient = () => {
    HideProactiveModal(false); // Close ProactiveYou modal
    setTimeout(() => {
      onRegisterPatient?.(); // Open next modal after modal closes
    }, 300); // 300ms delay matches Ionic modal animation
  };

  return (
    <>
      <div className="new-success-modalinner-wrap using-proactive-modal">
        <img
          src={proactiveYouLogo}
          alt="ps-logo"
          className="mb-28 mobile-image"
        />

        <h1>ProactiveYou </h1>
        <p>
          The ProactiveYou mobile app provides users with customized exercise
          and fitness plans derived from their assessments and assigned (as
          appropriate) by their clinician.
        </p>
        <p>
          To download, visit your mobile device’s app store or scan the QR code
          below to be taken directly to ProactiveYou’s download page.
        </p>

        <div className="qr-code-scanner mb-24">
          <div className="left-sec">
            <h2>iPhone QR</h2>
            <IonImg
              src={iphoneImg}
              alt="loader-icon"
              className="qr-code-img hide"
              placeholder={undefined}
            ></IonImg>
          </div>
          <div className="right-sec">
            <h2>Android QR</h2>
            <IonImg
              src={androidImg}
              alt="loader-icon"
              className="qr-code-img hide"
              placeholder={undefined}
            ></IonImg>
          </div>
        </div>

        <div className="d-flex justify-content-center w-100 gap-24">
          <IonButton
            placeholder={undefined}
            className="generic-btn-outline mb-0 h-64 fz-26"
            onClick={() => {
              GetPatientDetails();
            }}
          >
            Back
          </IonButton>
          <IonButton
            placeholder={undefined}
            className="generic-btn mb-0 h-64 fz-26"
            onClick={handleRegisterPatient}
          >
            Next: Register Patient
          </IonButton>
        </div>
      </div>
    </>
  );
};

export default ProactiveYouModal;
